module.exports = __webpack_public_path__ + "static/media/page_not_found.60312171.gif";